// extracted by mini-css-extract-plugin
export default {"row":"Shedule_row__Na6aw","select":"Shedule_select__9iZGO","input":"Shedule_input__X3MRm","burgerButton":"Shedule_burgerButton__nmhBn","droplist":"Shedule_droplist__M-ajM"};